var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconavideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 42 42",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4890 -4330)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.7778 0 0 .71016 4760.2 3011.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0373 0 0 1.5771 33.284 229.44)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.4688e-17 1.2483 -.78265 6.2976e-17 611.21 -779.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1465.7 710.03c0.08-0.145 0.24-0.235 0.41-0.235 0.16 0 0.32 0.09 0.4 0.235 1.25 2.315 5.08 9.388 6.26 11.563 0.08 0.136 0.07 0.3-0.01 0.431-0.08 0.132-0.23 0.212-0.39 0.212h-12.53c-0.16 0-0.31-0.08-0.39-0.212-0.08-0.131-0.09-0.295-0.01-0.431 1.18-2.175 5.01-9.248 6.26-11.563z",
    fill: "#b65454"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.85248 0 0 1.4272 -1202.6 55.203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1469 684.32c7.12 0 12.92 5.773 12.92 12.895s-5.8 12.896-12.92 12.896-12.91-5.774-12.91-12.896 5.79-12.895 12.91-12.895zm0 1.056c-6.53 0-11.84 5.305-11.84 11.839 0 6.535 5.31 11.84 11.84 11.84 6.54 0 11.84-5.305 11.84-11.84 0-6.534-5.3-11.839-11.84-11.839z",
    fill: "#b65454"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconavideo);
export default __webpack_public_path__ + "static/media/iconavideo.3c362fe846dca24c53b72afb3dddad17.svg";
export { ForwardRef as ReactComponent };